(function(){
  function doLayout(grid, reload){
    try {
      if (window.jQuery && jQuery.fn && jQuery.fn.isotope) {
        if (reload) jQuery(grid).isotope('reloadItems');
        jQuery(grid).isotope('layout');
        return true;
      } else if (window.Isotope && window.Isotope.data) {
        var iso = window.Isotope.data(grid);
        if (iso) { if (reload && iso.reloadItems) iso.reloadItems(); if (iso.layout) iso.layout(); return true; }
      }
    } catch(e) {}
    return false;
  }
  function markReady(grid){
    if (!grid || grid.classList.contains('isotope-ready')) return;
    [true, false, false].forEach(function(reload, i){ setTimeout(function(){ doLayout(grid, reload); }, i ? 80*i : 0); });
    try { window.dispatchEvent(new Event('resize')); } catch(e) {}
    grid.classList.add('isotope-ready');
  }
  function allImgsLoaded(grid){
    return Array.prototype.every.call(grid.querySelectorAll('img'), function(img){
      return (img.complete && img.naturalWidth > 0) || img.classList.contains('lazyloadt4sed');
    });
  }
  function watchGrid(grid){
    if (!grid) return;
    var enabled = grid.classList.contains('isotopet4s-enabled');
    if (!enabled) {
      var mo = new MutationObserver(function(){
        if (grid.classList.contains('isotopet4s-enabled')) { enabled = true; doLayout(grid, true); mo.disconnect(); }
      });
      mo.observe(grid, { attributes:true, attributeFilter:['class'] });
    }
    var links = grid.querySelectorAll('link[rel="stylesheet"], link[href*=".css"]');
    var pending = 0;
    links.forEach(function(l){
      if (l.sheet) return;
      pending++;
      l.addEventListener('load', function(){ pending = Math.max(0, pending - 1); doLayout(grid); }, { once:true });
      l.addEventListener('error', function(){ pending = Math.max(0, pending - 1); }, { once:true });
    });
    var imgs = grid.querySelectorAll('img');
    imgs.forEach(function(img){
      if ((img.complete && img.naturalWidth > 0) || img.classList.contains('lazyloadt4sed')) return;
      pending++;
      img.addEventListener('load', function(){ pending = Math.max(0, pending - 1); doLayout(grid); if (pending === 0) markReady(grid); }, { once:true });
      img.addEventListener('error', function(){ pending = Math.max(0, pending - 1); if (pending === 0) markReady(grid); }, { once:true });
    });
    try { var ro = new ResizeObserver(function(){ doLayout(grid); }); ro.observe(grid); } catch(e) {}
    [0, 60, 180, 400, 900, 1600].forEach(function(t,i){ setTimeout(function(){ doLayout(grid, i===0); }, t); });
    function onWinLoad(){ doLayout(grid, true); if (allImgsLoaded(grid)) markReady(grid); else setTimeout(function(){ markReady(grid); }, 800); }
    if (document.readyState === 'complete') onWinLoad();
    else window.addEventListener('load', onWinLoad, { once:true });
    document.addEventListener('lazyloaded', function(e){ var t = e && e.target; if (t && grid.contains(t)) { doLayout(grid); if (allImgsLoaded(grid)) markReady(grid); } }, true);
    setTimeout(function(){ markReady(grid); }, 3000);
  }
  document.addEventListener('DOMContentLoaded', function(){ document.querySelectorAll('.isotopet4s').forEach(function(grid){ watchGrid(grid); }); });
  document.addEventListener('shopify:section:load', function(){ document.querySelectorAll('.isotopet4s').forEach(function(grid){ watchGrid(grid); }); });
})();
